import { PanelStore } from '../interfaces';

export const getInvitationPasswordLoading = (state: PanelStore.RootState) => state.invitationPassword.loading;
export const getInvitationPasswordError = (state: PanelStore.RootState) => state.invitationPassword.error;
export const getInvitationPasswordErrorInfo = (state: PanelStore.RootState) => state.invitationPassword.errorInfo;
export const getInvitationPasswordSuccess = (state: PanelStore.RootState) => state.invitationPassword.success;
